import { useTranslation } from "react-i18next";
import { withRouter } from "common/src/router/compat";
import { useHistory } from "common/src/router/compat";
import { isMobile, isMobileOnly } from "react-device-detect";
import Cookies from "js-cookie";
import Logo from "./Logo";
import {
  DividerPub,
  Promoslider,
  QuickRegisterWrapper,
  StyledImg,
  StyledJoinCasino,
  StyledSlide,
  StyledSlideControllDetails,
  StyledSlideControlls,
  StyledSlider,
  StyledSliderControll,
  WelcomeTextWrapper,
} from "../styledComponents/StyledSlider";
import { StyledLink } from "../styledComponents/CommonStyledComponents";
import React, { useLayoutEffect, useRef, useState } from "react";
import MainDescription from "./MainDescription";
import QuickRegister from "./QuickRegister";
/* import QuickGameCategories from "./QuickGameCategories"; */

// Hide #hero-park only once `img` can paint, so the boot hero is not removed
// in the layout effect before it has been the LCP element.
function whenImageCanPaint(img, onReady) {
  if (!img) {
    onReady();
    return () => {};
  }

  let settled = false;
  let rafId = 0;
  const finish = () => {
    if (settled) return;
    settled = true;
    onReady();
  };
  const decodeThenFinish = () => {
    if (settled) return;
    if (typeof img.decode === "function") {
      img.decode().then(finish, finish);
    } else {
      finish();
    }
  };
  const onLoad = () => decodeThenFinish();
  const onError = () => finish();

  if (img.complete && img.naturalWidth > 0) {
    // Already decoded. Let this frame paint the boot hero, then swap.
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      if (!settled) decodeThenFinish();
    });
  } else {
    img.addEventListener("load", onLoad);
    img.addEventListener("error", onError);
  }

  return () => {
    settled = true;
    if (rafId) cancelAnimationFrame(rafId);
    img.removeEventListener("load", onLoad);
    img.removeEventListener("error", onError);
  };
}

const Slides = ({
  banners,
  currentLanguage,
  currentTheme,
  player,
  server,
  skin,
  landingImagePath,
  defaultLang,
  defaultCurrency,
  gamesPage,
  liveCasinoPage,
  sportsBookPage,
  pinHero,
}) => {
  const { t, i18n } = useTranslation();
  const { currency, country } = player;
  const history = useHistory();
  const promoRef = useRef(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const baseUrl = `/${
    i18n.language || window.localStorage.i18nextLng || defaultLang
  }`;

  const isSWEIp =
    server.geoIP.isoCode.toLowerCase() === "se" || country === "se"
      ? true
      : false;
  //const isUKIp = server && server.geoIP.isoCode.toLowerCase() === "gb" ? true : false;
  const geoIpFormated = server.geoIP.isoCode.toLowerCase();

  let playerCurrency = "eur";

  if (player) {
    playerCurrency = currency;
  } else if (skin !== "yet" && skin !== "fun" && skin !== "cac" && skin !== "hyc") {
    switch (server && geoIpFormated) {
      case "gb":
        playerCurrency = "gbp";
        break;
      case "se":
        playerCurrency = "sek";
        break;
      case "fi":
        playerCurrency = "eur";
        break;
      default:
        playerCurrency = defaultCurrency.toLowerCase();
        break;
    }
  } else {
    playerCurrency = defaultCurrency.toLowerCase();
  }

  //const isUK = player.country === "gb" ? true : false;
  // let playerCurrency =
  //currency !== undefined ? currency : isUKIp ? "gbp" : "eur";

  // Determine banner type based on page, skin, player status, and device
  const isSpecialSkin = skin === "abc";
  const playerStatus = player ? "in" : "out";

  const mobileInfix = isMobileOnly ? "_mob" : "";
  const mobileSuffix = isMobileOnly ? "_mob" : "";

  let bannerType;
  if (gamesPage) {
    bannerType = `games_page${mobileInfix}_${playerStatus}`;
  } else if (liveCasinoPage) {
    bannerType = `live_casino${mobileInfix}_${playerStatus}`;
  } else if (sportsBookPage) {
    bannerType = `sportsbook${mobileInfix}`;
  } else if (isSpecialSkin) {
    bannerType = `home_${playerStatus}${mobileSuffix}_new`;
  } else {
    bannerType = `homepage_${playerStatus}${mobileSuffix}`;
  }

  if (skin === "fun" && sportsBookPage && player) {
    bannerType = `sportsbook${mobileInfix}_${playerStatus}`;
  }

  if (Cookies.get("landr")) {
    let banner = JSON.parse(Cookies.get("landr"));
    let bannerLang = banner.page_language === "en" ? "" : banner.page_language;
    if (banner.type === "redirect" && banner.is_enabled) {
      //let image = banner.image;
      //console.log(banner);
      if (isMobileOnly) {
        banner["image"] = banner.mobile_image;
      }
      banner["sslLink"] =
        server.cdn.replace("https://", "") +
        landingImagePath +
        bannerLang +
        "/";
      banner["url"] = "/" + banner.link;
      banners = [banner];
    }
  } else {
    // console.log(banners)
    let allBanners = banners;

    banners = banners.filter(
      (banner) =>
        banner.currency === playerCurrency && banner.section === bannerType,
    );

    //for logged in players, if there is no banner for currency, see if there is banner for default currency
    if (player && banners.length < 1) {
      banners = allBanners.filter(
        (banner) =>
          banner.currency === defaultCurrency && banner.section === bannerType,
      );
    }
  }

  const changeBannerThema = (banner) => {
    return currentTheme === "dark"
      ? banner.replace("light.", "dark.")
      : banner.replace("dark.", "light.");
  };

  const heroImg =
    typeof document !== "undefined" ? document.getElementById("hero-img") : null;
  const heroFile = (heroImg && heroImg.dataset.heroFile) || "";
  const leadName =
    banners[0] && banners[0].image ? changeBannerThema(banners[0].image) : "";
  const leadFile = leadName.split("?")[0].split("/").pop();
  const leadKnown = Boolean(banners[0] && banners[0].image);
  // Boot hero file comes from the server (first BO banner) or, on skins not
  // migrated yet, the fixed main-hero(-mobile).webp. Pin when the lead matches.
  const pinLead =
    Boolean(pinHero) &&
    leadKnown &&
    heroFile !== "" &&
    leadFile.toLowerCase() === heroFile.toLowerCase() &&
    !!heroImg;

  // Keep #hero-img in #hero-park. Moving it resets LCP. #root/#main clip
  // overflow, so the overlap is a negative margin on #root, not on the slider.
  // A different lead image stays under that overlap until it can paint, then
  // #hero-park is hidden in that same frame.
  useLayoutEffect(() => {
    if (!pinHero) return undefined;
    const park = document.getElementById("hero-park");
    const root = document.getElementById("root");
    const img = document.getElementById("hero-img");
    let cancelled = false;
    let stopWaiting = () => {};

    const applyPin = () => {
      if (cancelled || !root || !park) return;
      document.documentElement.classList.remove("hero-off");
      const height = park.offsetHeight;
      if (!height) return;
      root.style.marginTop = `-${height}px`;
    };

    if (!pinLead) {
      if (!root || !park) return undefined;
      if (!leadKnown) {
        root.style.marginTop = "";
        return undefined;
      }
      document.documentElement.classList.remove("hero-off");
      const height = park.offsetHeight;
      if (height) root.style.marginTop = `-${height}px`;
      const hidePark = () => {
        if (cancelled) return;
        root.style.marginTop = "";
        document.documentElement.classList.add("hero-off");
      };
      const replacement = () =>
        promoRef.current && promoRef.current.querySelector("img");
      const waitFor = (img) => whenImageCanPaint(img, hidePark);
      const first = replacement();
      if (first) {
        stopWaiting = waitFor(first);
      } else {
        let stopInner = () => {};
        const rafId = requestAnimationFrame(() => {
          if (cancelled) return;
          stopInner = waitFor(replacement());
        });
        stopWaiting = () => {
          cancelAnimationFrame(rafId);
          stopInner();
        };
      }
      return () => {
        cancelled = true;
        stopWaiting();
      };
    }

    applyPin();
    window.addEventListener("resize", applyPin);
    if (img) img.addEventListener("load", applyPin);
    return () => {
      cancelled = true;
      stopWaiting();
      window.removeEventListener("resize", applyPin);
      if (img) img.removeEventListener("load", applyPin);
    };
  }, [pinHero, pinLead, leadKnown]);

  useLayoutEffect(() => {
    if (!pinHero) return undefined;
    return () => {
      const root = document.getElementById("root");
      if (root) root.style.marginTop = "";
      document.documentElement.classList.add("hero-off");
    };
  }, [pinHero]);

  let slider;
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    fade: true,
    speed: 500,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleClickTextWrapper = (banner) => {
    if (
      skin === "abc" ||
      skin === "yet" ||
      skin === "fun" ||
      skin === "cac" ||
      skin === "hyc"
    ) {
      if (player) {
        document.getElementById("scroll-to-category-onlogin").scrollIntoView();
      } else {
        history.push(baseUrl + banner.url);
      }
    }
  };

  const handleQuickRegister = () => {
    if (email.length > 0 && name.length > 0 && lastName.length > 0) {
      // Store the registration data in localStorage
      localStorage.setItem(
        "registrationData",
        JSON.stringify({
          email: email,
          firstName: name,
          lastName: lastName,
        }),
      );

      // Navigate to the registration page
      history.push(baseUrl + "/register").then(() => {
        window.location.reload();
      });
    }
  };

  const displayDescription = (banner) => {
    let bannerObject;
    if (banner.description && banner.description.length) {
      bannerObject = JSON.parse(banner.description);
    } else {
      bannerObject = false;
    }

    return (
      banner.description &&
      bannerObject &&
      (bannerObject[geoIpFormated] || bannerObject["all"]) && (
        <StyledSlideControlls>
          <WelcomeTextWrapper onClick={() => handleClickTextWrapper(banner)}>
            <StyledSlideControllDetails
              dangerouslySetInnerHTML={{
                __html: bannerObject[geoIpFormated]
                  ? bannerObject[geoIpFormated]
                  : bannerObject["all"],
              }}
            ></StyledSlideControllDetails>

            {skin === "qbc" ||
            (skin === "pub" &&
              (liveCasinoPage || sportsBookPage || isMobile)) ||
            (skin === "fun" &&
              sportsBookPage) ? null : (
              <StyledLink
                id={""}
                btn="true"
                slidcontroll="true"
                to={"/" + currentLanguage + banner.url}
              >
                {player
                  ? t("label_play", "Play")
                  : t("label_sign_up_now", "Sign up now")}
              </StyledLink>
            )}
            {skin === "pub" && !isMobile && <DividerPub banner />}
            {skin === "qbc" && (
              <QuickRegister
                skin={skin}
                player={player}
                setEmail={setEmail}
                setName={setName}
                setLastName={setLastName}
                handleQuickRegister={handleQuickRegister}
                currentLanguage={currentLanguage}
                banner={banner}
              />
            )}
          </WelcomeTextWrapper>
        </StyledSlideControlls>
      )
    );
  };

  return (
    <Promoslider ref={promoRef} className={pinLead ? "hero-host" : undefined}>
      {/* {skin === "abc" && isMobile && (
        <QuickGameCategories currentLanguage={currentLanguage} />
      )} */}
      <StyledSlider {...settings} ref={(c) => (slider = c)}>
        {banners.map((banner, index) => {
          const pinThis = pinLead && index === 0;
          return (
          <StyledSlide key={index}>
            {pinThis ? (
              <div className="hero-spacer" aria-hidden="true" />
            ) : (
            <StyledLink
              to={"/" + currentLanguage + banner.url}
              unclicable={skin === "pub"}
              aria-label={
                player
                  ? t("label_play", "Play")
                  : t("label_sign_up_now", "Sign up now")
              }
            >
              <picture>
                <StyledImg
                  as="source"
                  {...(index === 0 ? { fetchpriority: "high" } : {})}
                  media="(min-width: 768px)"
                  srcSet={`https://${
                    banner.sslLink + changeBannerThema(banner.image)
                  }`}
                  type="image/webp"
                />
                <StyledImg
                  {...(index === 0
                    ? { fetchpriority: "high", loading: "eager" }
                    : { loading: "lazy" })}
                  decoding="async"
                  alt=""
                  src={`https://${
                    banner.sslLink + changeBannerThema(banner.image)
                  }`}
                  srcSet={`https://${
                    banner.sslLink + changeBannerThema(banner.image)
                  }`}
                  sizes="100vw"
                />
              </picture>
            </StyledLink>
            )}
            {(skin === "yet" ||
              skin === "fun" ||
              skin === "cac" ||
              skin === "hyc" ||
              skin === "abc" ||
              skin === "qbc" ||
              skin === "bec" ||
              skin === "pub") &&
              banner.description.length > 1 &&
              displayDescription(banner)}
          </StyledSlide>
          );
        })}
      </StyledSlider>
    </Promoslider>
  );
};

export default withRouter(Slides);
